import { FunctionComponent, useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'

import Container from 'components/GlobalStyles/Marketing/Container'
import Text from 'components/GlobalStyles/Text'
import RoundedButton from 'components/RoundedButton'
import Spacer from 'components/Spacer'

const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin: 36px 0;

  img {
    height: 40px;
    width: auto;
  }

  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    flex-direction: row;
    margin: 56px 0;
  }
`

const Image = styled.img`
  margin: 12px 0;
  height: 40px;
  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    margin: 0;
  }
`

const GetListedOn: FunctionComponent = () => {
  const theme = useContext(ThemeContext)
  return (
    <Container>
      <Spacer
        size={72}
        tabletSize={48}
        responsiveSize={32}
      />
      <Text
        fontSize={24}
        fontWeight={800}
        textAlign="center"
        color={theme.colors.grey23}
      >
        Get listed on
      </Text>
      <LogoContainer>
        <Image
          src={`${process.env.CDN_BASE_URL}/q_auto,w_200/amazon/assets/zillow.png`}
          alt="Zillow logo"
          width="200"
          height="40"
        />
        <Image
          src={`${process.env.CDN_BASE_URL}/q_auto,w_200/amazon/assets/trulia.png`}
          alt="Trulia logo"
          width="200"
          height="40"
        />
        <Image
          src={`${process.env.CDN_BASE_URL}/q_auto,w_200/amazon/assets/redfin.png`}
          alt="Redfin logo"
          width="200"
          height="40"
        />
        <Image
          src={`${process.env.CDN_BASE_URL}/q_auto,w_200/amazon/assets/Realtor.com_logo.png`}
          alt="Realtor.com logo"
          width="200"
          height="40"
        />
        <Image
          src={`${process.env.CDN_BASE_URL}/q_auto,w_200/amazon/assets/mls-logo-transparent.png`}
          alt="MLS logo"
          width="200"
          height="40"
        />
      </LogoContainer>
      <RoundedButton
        text="How It Works"
        href="/how-it-works"
        background={theme.colors.blue4}
        hoverBackground={theme.colors.blue9}
        color={theme.colors.white}
        boxShadow={`0px 12px 16px ${theme.colors.transparentBlue4Alpha25}`}
        fontSize={12}
        radius={50}
        height={44}
        width={240}
        center
      />
      <Spacer
        size={72}
        tabletSize={48}
        responsiveSize={32}
      />
    </Container>
  )
}

export default GetListedOn
